import { Statistic, Space } from "antd";

export default function StatCard(props) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
      {props.icon}
      <Statistic
        title={props.title}
        value={props.value}
        valueStyle={{
          color: props.color || "#1890FF",
          fontSize: "calc(16px + 1vw)",
          fontWeight: "bold",
          textAlign: "center",
          textOverflow: "ellipsis",
        }}
        prefix={props.prefix}
      />
    </div>
  );
}
